import { createApi } from "@reduxjs/toolkit/query/react";
import { uploadBaseQueryWithRefreshTokenHandler } from "../authFetchBaseQuery";
import {
  API_GET_DEALER_IMPORT_JOB,
  API_GET_DEALER_IMPORT_JOBS,
  API_GET_DEALER_IMPORT_TEMPLATE,
  API_POST_DEALER_IMPORT_UPLOAD,
} from "../ApiConstants";
import {
  JobDetail,
  JobSummary,
  UploadResponse,
} from "../../types/dealerImportTypes";

/**
 * RTK Query API slice for the RO Writer dealer import feature.
 * Handles uploading import files, listing import jobs, and fetching job detail.
 */
export const dealerImportApi = createApi({
  reducerPath: "dealerImportApi",
  baseQuery: uploadBaseQueryWithRefreshTokenHandler,
  tagTypes: ["ImportJobs"],
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    uploadDealerImport: builder.mutation<UploadResponse, FormData>({
      query: (form) => ({
        url: API_POST_DEALER_IMPORT_UPLOAD,
        method: "POST",
        body: form,
      }),
      invalidatesTags: ["ImportJobs"],
    }),
    listImportJobs: builder.query<JobSummary[], void>({
      query: () => ({ url: API_GET_DEALER_IMPORT_JOBS, method: "GET" }),
      providesTags: ["ImportJobs"],
    }),
    getImportJob: builder.query<JobDetail, string>({
      query: (jobId) => ({ url: API_GET_DEALER_IMPORT_JOB(jobId), method: "GET" }),
      providesTags: ["ImportJobs"],
    }),
    downloadTemplate: builder.query<string, void>({
      query: () => ({
        url: API_GET_DEALER_IMPORT_TEMPLATE,
        method: "GET",
        responseHandler: (response) => response.text(),
        cache: "no-cache",
      }),
    }),
  }),
});

export const {
  useUploadDealerImportMutation,
  useListImportJobsQuery,
  useGetImportJobQuery,
  useLazyDownloadTemplateQuery,
} = dealerImportApi;
